/* eslint-disable */

import {debounce} from "./../utils/debounce.js";

(function () {
  window.addEventListener(`scroll`, debounce(function() {
    var scrollPos = $(window).scrollTop();
    var hSec = $(".title-block").outerHeight();

    if (scrollPos >= hSec) {
      jQuery('#toTop').fadeIn(200);
    } else {
      jQuery('#toTop').fadeOut(200);
    }
  }), {
    passive: true
  });

  jQuery('#toTop').click(function () {
    jQuery('body,html').animate({
      scrollTop: 0
    }, 800);
  });
})();
